import React from 'react';
import style from './Tooltip.scss';
import { Icon } from '../../../../common/Icon';

export const Tooltip = ({ title, text, onXClicked, tooltipStyle }) => {
    const styleName = `bubble_${tooltipStyle}`;
    return (
        <div className={`${style[styleName]} ${style[tooltipStyle]}`}>
            {title && <div className={style.wrapper}>
                <div className={style.title}>{title}</div>
            </div>}
            <div className={style.text}>{text}</div>
            <Icon type='tooltipIconClose' className={style.closeButton} onClick={() => onXClicked()}/>
        </div>
    );
};
